{
  "toast": {
    "success": "Success",
    "error": "Error",
    "warning": "Warning",
    "attention": "Attention",
    "subtitle": {
      "fileextension": "Only JPEG, PNG or PDF files are accepted to this upload",
      "loginerror": "Authentication error. Please login again to continue.",
      "individualdeleted": "Individual succesfully deleted",
      "individualupdated": "Individual succesfully updated",
      "individualadded": "Individual succesfully added",
      "accountadded": "Account succesfully added",
      "selectaccount": "Please select an account before choose an option",
      "copiedtoclipboard": "Deposit informations copied to clipboard",
      "reviewfieldchanged": "This field has already been modified",
      "documentschange": "One of the documents encountered an error during processing. Please upload it again.",
      "statesus": "Please select a state from the provided list",
      "codealreadysent": "The code has already been sent again to your email. Please check your inbox or spam folder. You can send again in 5 minutes.",
      "codesentagain": "The code has been sent again to your email succesfully",
      "beneficiaryunderanalysis": "The beneficiary is under analysis. You will be notified when the process is completed.",
      "beneficiarydeleted": "Beneficiary succesfully deleted",
      "passwordchanged": "Your password has been changed successfully",
      "beneficialownermissing": "You must add at least one BENEFICIAL OWNER owning 20% or more of the company",
      "feeupdate": "Fee updated successfully",
      "transactionapproved": "Transaction approved successfully",
      "transactionrejected": "Transaction cancelled successfully",
      "accountclosed": "The account has been closed successfully",
      "applicationreadyforsubmit": "The application is ready to be submitted",
      "userdataupdated": "Your data has been updated successfully",
      "formnotfillentirely": "Please fill the update information form entirely before submit",
      "filetoolarge10mb": "The file is too large. Please upload a file smaller than 10MB",
      "tokennotfound": "The token address was not found to the selected chain",
      "failedtoapprove": "Failed to approve the transaction. Please try again later.",
      "alltransactionsloaded": "All transactions for this account have been loaded",
      "norailsupported": "No rails supported for this beneficiary."
    }
  },
  "button": {
    "getstarted": "GET STARTED",
    "nextstep": "NEXT STEP",
    "signin": "SIGN IN",
    "signup": "SIGN UP",
    "upload": "UPLOAD",
    "select": "SELECT",
    "selectdaterange": "SELECT DATE RANGE",
    "seeinstructions": "SEE INSTRUCTIONS",
    "submitapplication": "SUBMIT APPLICATION",
    "updateapplication": "UPDATE APPLICATION",
    "save": "SAVE",
    "confirm": "CONFIRM",
    "addaccount": "ADD ACCOUNT",
    "newbeneficiary": "ADD NEW BENEFICIARY",
    "addintermediarybank": "ADD INTERMEDIARY BANK",
    "addintermediaryaddress": "ADD INTERMEDIARY ADDRESS",
    "confirmtransaction": "CONFIRM TRANSACTION",
    "createexchange": "CREATE EXCHANGE",
    "logout": "Logout",
    "download": "DOWNLOAD",
    "submit": "SUBMIT",
    "backtologin": "BACK TO LOGIN",
    "review": "REVIEW",
    "backtohome": "BACK TO HOMEPAGE",
    "selectbeneficiary": "SELECT BENEFICIARY",
    "2fa": "ENABLE 2FA",
    "disable2fa": "DISABLE 2FA",
    "changepassword": "CHANGE PASSWORD",
    "sendcode": "SEND CODE",
    "update": "UPDATE",
    "gotouserpanel": "GO TO USER PANEL",
    "understand": "OK, I UNDERSTAND",
    "deposit": "DEPOSIT",
    "seebeneficiaries": "SEE BENEFICIARIES",
    "createwalletaddress": "CREATE WALLET ADDRESS",
    "approveinwallet": "APPROVE IN WALLET",
    "connecttronwallet": "CONNECT TRON WALLET",
    "connectwallet": "CONNECT WALLET",
    "apply": "APPLY",
    "sendusingizzi": "SEND USING IZZI"
  },
  "errorscreen": {
    "title": "Something went wrong. Please, try again later.",
    "subtitle": "If the problem persists, please contact the support."
  },
  "error": {
    "required": "This field is required",
    "email": "Please enter a valid email address",
    "server": "An error ocurred. Try again later or contact the support.",
    "network": "You don't have network connection. Please check your connection and try again.",
    "sessionexpired": "Your session has expired. Please login again to continue.",
    "paymentalrail": "Missing the blockchain and asset information",
    "password": {
      "minlength": "Password must be at least 8 characters long",
      "maxlength": "Password cannot be more than 20 characters long",
      "number": "Password must contain at least one number",
      "letters": "Password must contain at least one uppercase letter",
      "character": "Password must contain at least one special character"
    },
    "username": {
      "minlength": "Username must be at least 8 characters long",
      "maxlength": "Username cannot be more than 16 characters long",
      "pattern": "Username must contain only numbers and letters"
    },
    "date": "Please enter a valid date",
    "amountgreater": "The amount entered for transfer is greater than the available balance",
    "amountequalszero": "The amount entered must be greater than $0.00",
    "amountgreaterthan501k": "Transfers above 501k are not allowed. Please contact the support for more information.",
    "noaccountwithasset": "There is no account with this asset to complete the transaction. Please open an account with this asset first."
  },
  "modal": {
    "individual": {
      "title": "Ownership Information",
      "subtitle": "Please fill the fields",
      "advice": "You should add at least one BENEFICIAL OWNER",
      "example": "CEO"
    },
    "warning": {
      "title": "Warning",
      "subtitle": "Are you sure that you want to delete this item?",
      "advice": "This action cannot be undone."
    },
    "addaccount": {
      "title": "Add Account",
      "subtitle": "Each account will hold only one type of asset",
      "agreement": "I agree to the terms and conditions to use Izzi Wallet accounts"
    },
    "depositinformations": {
      "title": "Deposit Informations",
      "subtitle": "Choose an option below to see the respective deposit information"
    },
    "reviewtransaction": {
      "title": "Review Transaction",
      "section": {
        "fees": "Fees",
        "beneficiary": "Beneficiary"
      }
    },
    "transaction": {
      "title": "Transaction"
    },
    "2fa": {
      "title": "Enter the security code",
      "subtitle": "Please enter the current code in your authenticator app to proceed."
    },
    "details": {
      "title": "Transaction Receipt"
    },
    "reviewexchange": {
      "title": "Review Exchange",
      "section": {
        "fees": "Fees",
        "beneficiary": "Beneficiary"
      }
    },
    "upload": {
      "title": "Upload Instructions",
      "subtitle": "Document photo example",
      "topic": {
        "checkexample": "Check the example on top",
        "passport": "The passport must be opened in the photo, like the example on top.",
        "livephoto": "You must upload a live photo. Scanned photos will be rejected.",
        "format": "Only JPEG, PNG or PDF files are accepted to this upload",
        "sameid": "The identity document in the selfie must be the same identity document uploaded as part of the application.",
        "readable": "The information on the identity document should be clearly readable e.g. document number, name, issued date, expiration date."
      }
    },
    "alert2fa": {
      "title": "Security Alert",
      "advice": "The Two-Factor Authentication (2FA) will be required for all Izzi Wallet users starting from October 1st, 2024. Please consider enabling it now in the User Panel."
    },
    "nonus": {
      "title": "Warning",
      "content": "At this time, non-US customers are unable to make ACH and FEDWIRE transactions. Additionally, US customers can only make ACH and FEDWIRE transactions to other US entities. We apologize for the inconvenience and are working to resolve this issue as quickly as possible.",
      "dontremindme": "Don't show this message again"
    },
    "sessionexpired": {
      "title": "Session Expired",
      "content": "Your session has expired. Please login again to continue."
    }
  },
  "placeholder": {
    "country": "Search for a country",
    "city": "Search for a city",
    "state": "Search for a state",
    "contact": "Search contact",
    "beneficiary": "Search beneficiary",
    "choose": "Choose an option",
    "selectdate": "Select Date",
    "selectdaterange": "Select Date Range",
    "copytoclipboard": "Copy to clipboard",
    "lastupdate": "Last Update",
    "lastminute": "~ 1 minute ago",
    "optional": "Optional",
    "details": "Details",
    "receipt": "Receipt",
    "download": "Download",
    "downloadcustomerdata": "Download Customer Data",
    "downloadcounterpartiesdata": "Download Counterparties Data",
    "transactionsempty": "There is no transaction history for this account",
    "contactsempty": "There is no contacts registered for this account",
    "typetosearch": "Type to search",
    "date": "Date",
    "amount": "Amount",
    "transfertype": "Transfer Type",
    "destinator": "Sender/Receiver",
    "sender": "Sender",
    "receiver": "Receiver",
    "rail": "Rail",
    "status": "Status",
    "filter": "Filter",
    "clearfilter": "Clear Filter",
    "lastfifteen": "Last 15 days",
    "lastthirty": "Last 30 days",
    "export": "Export",
    "settingaccount": "Setting up account",
    "adviceaccount": "Your account is almost ready to use! Stay tuned.",
    "chooseasset": "Choose the asset to see the volume"
  },
  "terms": {
    "or": "or",
    "at": "at",
    "send": "Send",
    "receive": "Receive",
    "details": "Details",
    "delete": "Delete",
    "cancel": "Cancel",
    "accept": "Accept",
    "confirm": "Confirm",
    "decline": "Decline",
    "receipt": "Receipt",
    "backtologin": "Back to login",
    "searchcustomer": "Search Customer...",
    "searchaccountid": "Search Account ID...",
    "searchcounterparty": "Search Counterparty...",
    "searchtransactionid": "Search Transaction ID...",
    "requireddocuments": "Required Documents",
    "filter": "Filter",
    "setmax": "Set Max",
    "accountid": "Account ID",
    "startdate": "Start Date",
    "enddate": "End Date",
    "charts": "Charts",
    "transactions": "Transactions List",
    "typeemail": "Enter your e-mail address",
    "typepassword": "Enter your password",
    "exportcustomers": "Download Customers Data",
    "exportcounterparties": "Download Counterparties Data",
    "memo": "Message sent to bank",
    "edit": "Edit",
    "fetchingtransactions": "Fetching transactions for the selected date range...",
    "25percent": "25%",
    "50percent": "50%",
    "75percent": "75%",
    "100percent": "100%",
    "documents": "Documents",
    "userdata": "User Data",
    "generalinformation": "General Information",
    "corporateindividuals": "Corporate Individuals",
    "deposit": "Deposit",
    "fiat": "FIAT",
    "crypto": "CRYPTO",
    "creatingwallet": "Creating wallet address...",
    "switchtotron": "Switch to TRON wallet",
    "switchtogeneral": "Switch to other wallet chain",
    "disconnect": "Disconnect",
    "filters": "Filters",
    "clearfilters": "Clear Filters",
    "acceptedfiles": "Accepted File Types",
    "connectedwith": "Connected with",
    "tronlinkalert": "TronLink is available for Chrome, Firefox, and Microsoft Edge browsers. Please install the extension to use it"
  },
  "status": {
    "authorized": "Pending Review",
    "pending": "Processing",
    "posted": "Completed",
    "rejected": "Rejected",
    "cancelled": "Cancelled",
    "scheduled": "Scheduled",
    "accepted": "Accepted",
    "unconfirmed": "Unconfirmed",
    "failed": "Failed",
    "active": "Active",
    "pending_l2f": "Pending"
  },
  "transfer": {
    "ach": "ACH fee",
    "processing": "Processing Fee",
    "wire": "Wire Fee",
    "swift": "Swift Fee",
    "exchangefee": "Exchange Fee",
    "swiftTransferIn": "Incoming Swift Transfer",
    "swiftTransferOut": "Outgoing Swift Transfer",
    "achTransferIn": "Incoming ACH Transfer",
    "achTransferOut": "Outgoing ACH Transfer",
    "wireTransferIn": "Incoming Wire Transfer",
    "wireTransferOut": "Outgoing Wire Transfer",
    "cryptoTransferIn": "Incoming Crypto Transfer",
    "cryptoTransferOut": "Outgoing Crypto Transfer",
    "deposit": "Incoming Transfer",
    "withdrawal": "Outgoing Transfer",
    "fee": "Fees",
    "exchange": "Exchange",
    "internalTransfer": "Internal Transfer",
    "otcInternalTransfer": "OTC Internal Transfer",
    "return": "Wire Return"
  }
}
